export default __webpack_public_path__ + "0af762ed70e5e04a036b43a6429415a3.svg";